import auth from '@/middleware/auth';
import log from '@/middleware/log';
import admin from '@/middleware/admin';

export default [
  {
    path: '/automation',
    redirect: '/visual-programming',
    meta: {
      middleware: [auth, admin, log],
    },
  },
  {
    path: '/automation/update/:automationId',
    redirect: '/visual-programming/:automationId',
    meta: {
      middleware: [auth, admin, log],
    },
  },
];



// WEBPACK FOOTER //
// ./src/router/jRouterAutomation.js